import React from 'react'

const SonarSettings = () => {
  return (
    <div>SonarSettings</div>
  )
}

export default SonarSettings